import { RequestQuery, useUpdatePartRequestMutation } from '@/buyers/_gen/gql'
import useGqlClient from '@/buyers/hooks/useGqlClient'
import Action from '@/gf/components/Action'
import useMsgs from '@/gf/hooks/useMsgs'
import { UNKNOWN_ERROR } from '@/gf/providers/MsgsProvider'
import PartCombobox from './PartCombobox'

const PartNumberAction = ({
  rfqPart,
}: {
  rfqPart: RequestQuery['requestForQuotesSearch']['requestForQuotes'][number]['partRequests'][number]
}) => {
  const client = useGqlClient()
  const [_msgs, msgsMgr] = useMsgs()
  const [updatePartRequest] = useUpdatePartRequestMutation({ client })

  const handleSelectPart = (part: { mpn: string; description: string }) => {
    return updatePartRequest({
      variables: { partRequestId: rfqPart.id, mpn: part.mpn, description: part.description },
    })
      .then(() => {
        return client.reFetchObservableQueries()
      })
      .catch((err: Error) => {
        msgsMgr.add(err.message || UNKNOWN_ERROR, 'negative')
      })
  }

  return (
    <PartCombobox
      Trigger={<Action.T className="text-sm">{rfqPart.mpn || 'Select part'}</Action.T>}
      onPartSelected={handleSelectPart}
    />
  )
}

export default PartNumberAction
